
import { getCertificateScans } from 'store/certificates/actions'
import type { GetCertificateScansPayload, ScansResponseData } from 'store/certificates/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'


type UseCertificateScansParams = GetCertificateScansPayload

type UseCertificateScansResult = {
  data: ScansResponseData | null
} & UseQuerySelectResult<UseCertificateScansParams>

export const useCertificateScans = (
  params: UseCertificateScansParams,
  options?: UseQuerySelectOptions
): UseCertificateScansResult => {
  const result = useQuerySelect(getCertificateScans, params, options)
  const data = useSelector(state => state.certificates.certificateScans)

  return {
    data,
    ...result,
  }
}
